export default "__VITE_ASSET__BSi37V4e__"